module.exports = __webpack_public_path__ + "img/gallery-img-3.9e198c09.jpg";